import { ReduceStore } from "flux/utils";
import Dispatcher from "Dispatcher";
import LoadObject from "./LoadObject";
import SuperRecordListActions from "./SuperRecordListActions";
import userStore from "data/userStore";
import dotProp from "dot-prop-immutable";
import DataManager from "./DataManager";
import { hotLoadObject } from "./storeUtils";
import SuperRecordActions from "./SuperRecordActions";
import StereotypesStore from "data/StereotypesStore";

/**
 * I store List<ID> per superrecord key. I do NOT store actual records!
 */
class SuperRecordListStore extends ReduceStore {

    constructor() {
        super(Dispatcher);
    }

    getInitialState() {
        return {};
    }

    reduce(state, action) {
        switch (action.type) {
            case SuperRecordListActions.START_LOAD: {
                this.__dispatcher.waitFor([
                    userStore.getDispatchToken(),
                ]);

                const getPromise = () =>
                    DataManager.loadSuperrecordList(
                        action.key,
                        userStore.getActiveOrgKey(),
                    );
                let p;
                const modelLO = StereotypesStore.getStereotypeLO(action.key);
                if (modelLO.hasValue()) {
                    p = getPromise();
                } else {
                    p = new Promise(resolve => {
                        const token = Dispatcher.register(() => {
                            this.__dispatcher.waitFor([
                                StereotypesStore.getDispatchToken(),
                            ]);
                            if (!StereotypesStore.hasChanged()) return;
                            const lo = StereotypesStore.getStereotypeLO(action.key);
                            if (!lo.hasValue()) return;
                            resolve(getPromise());
                            Dispatcher.unregister(token);
                        });
                    });
                }
                return dotProp.set(state, action.key, LoadObject.loading(p));
            }

            case SuperRecordListActions.LOADED: {
                if (dotProp.get(state, action.key) == null) return state;
                return dotProp.set(state, action.key, lo =>
                    lo.receiveValue(action.data.map(r =>
                        r.id
                    ))
                );
            }

            case SuperRecordListActions.LOAD_ERROR: {
                if (dotProp.get(state, action.key) == null) return state;
                return dotProp.set(state, action.key, lo =>
                    lo.receiveError(action.error));
            }

            case SuperRecordActions.CREATED:
            case SuperRecordActions.UPDATED:
            case SuperRecordActions.DELETED: {
                // this is a _little_ draconian, but it ain't wrong!
                return this.getInitialState();
            }

            default:
                return state;
        }
    }

    getList(key) {
        return this.getListLO(key).getRequiredValue();
    }

    getListLO(key) {
        return hotLoadObject(
            () => this.getState()[key],
            () => Dispatcher.dispatch({
                type: SuperRecordListActions.START_LOAD,
                key,
            }),
        );
    }

}

export default new SuperRecordListStore();



// WEBPACK FOOTER //
// ./app/data/SuperRecordListStore.js